/**
 * Où se place la ligne du présent au-dessus de la tête de lecture.
 *
 * Arithmétique pure, isolée du composant comme `playhead-distance.ts` : elle
 * se teste sans roll ni renderer Pixi.
 *
 * # Un seul nombre pour la tête et la ligne
 *
 * La tête de lecture court derrière le présent du délai de restitution que le
 * transport local tient (`LocalTransport.getPlayoutDelay`). La ligne marque ce
 * présent ; sa hauteur au-dessus de la tête est donc ce même délai, converti en
 * pixels — et rien d'autre. Le roll ne reçoit pas un second nombre pour la
 * ligne : il lit celui du transport à chaque image.
 *
 * Il en a reçu un, par une entrée à part du studio, alimentée par le même
 * effet que le transport. Deux entrées peuvent se désaccorder, et un appelant
 * qui les désaccorde est un défaut en attente — la ligne se dessine à un
 * endroit plausible, la tête court à un autre, et rien ne le dit. Une seule
 * entrée ne le peut pas.
 *
 * # Pourquoi par la durée de la fenêtre visible
 *
 * On passe par la durée de la fenêtre plutôt que par un facteur global : la
 * conversion tick → seconde dépend de la carte de tempo, donc d'où l'on se
 * trouve dans le morceau. Un changement de tempo modifie la hauteur de la
 * bande sans que le délai ait bougé, et c'est correct — la bande dit un temps,
 * pas un nombre de mesures.
 */
export function nowLineOffsetPx(
  delaySeconds: number,
  windowSeconds: number,
  rollHeight: number,
): number {
  if (delaySeconds <= 0 || windowSeconds <= 0) {
    return 0;
  }

  return (delaySeconds / windowSeconds) * rollHeight;
}
